// Recovered compiled webpack factory 36795. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { n: () => n });
  let n = (t) => "string" == typeof t && "svg" === t.toLowerCase();
}
